import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import OnBoardingFormLanding from "../../components/staff-onboarding/on-boarding-form/OnBoardingFormLanding";

const OnBoardingForm = () => {
  const userInfoData = useSelector(selectUser);

  return <OnBoardingFormLanding userInfoData={userInfoData} />;
};

export default OnBoardingForm;
